import {store} from "../../redux/store";
import PlaygroundApi from "../playgroundApi";
import {getSignInDataFromLocalStorage} from "./sign-in-data";
import {IMyProfile} from "../../redux/my-profile/myProfileSlice";
import {myProfileStore} from "../../redux/my-profile/myProfileStore";


class MyProfile {
  protected unsub: () => void;

  constructor() {
    // attempt to load profile
    void this.loadProfileIfNotPriorLoaded();
    // subscribe to store changes to reload when undefined
    this.unsub = store.subscribe(this.onStoreUpdate.bind(this));
  }

  destroy(){
    this.unsub();
  }

  protected setRequestStatus(status: "loading" | "error" | "completed"){
    myProfileStore.setRequestStatus(status);
  }

  protected clearProfile(){
    myProfileStore.clearMyProfile();
  }

  protected setProfile(profile: IMyProfile){
    const {firstName, lastName, username, email, joinedAt, userId, sessionId, membership} = profile;
    myProfileStore.setMyProfile({firstName, lastName, username, email, joinedAt, userId, sessionId, membership});
  }

  onStoreUpdate(): void {
    void this.loadProfileIfNotPriorLoaded();
  }

  protected async loadProfileIfNotPriorLoaded() {
    const shouldLoadProfile = myProfileStore.getRequestStatus() === undefined;
    // should we request profile
    if (!shouldLoadProfile) {
      // nothing to do, return to exit
      return;
    }
    // update request status
    void await this.loadProfile();
  }

  public async loadProfile() {
    // get user id and session from local storage
    const {userId, sessionId} = getSignInDataFromLocalStorage() ?? {};
    // update request status
    this.setRequestStatus("loading");
    try {
      // request current user profile from api
      const {firstName, lastName, username, email, joinedAt, membership} = await PlaygroundApi.myProfile();
      // set my profile to store
      this.setProfile({userId, sessionId, firstName, lastName, username, email, joinedAt, membership});
      // update request status
      this.setRequestStatus("completed");
    }catch (e) {
      this.setRequestStatus("error");
    }
  }

  /**
   * NOTE: This method does not work correctly anymore. If you need to reload profile, use `loadProfile` method instead.
   */
  public triggerReload(): void {
    // trigger reloading profile by clearing profile
    this.clearProfile();
  }

}

export const myProfile = new MyProfile();
